var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MsAjaxTemplate',{attrs:{"template-name":"build-canvas-settings-workflow","ready-dependencies":_vm.readyDependencies}})
}
var staticRenderFns = []

export { render, staticRenderFns }